import { IContent } from 'models/content.model';

export const content: IContent = {
  nl: {
    paymentOptionIdeal: 'Betalen via iDEAL | Wero',
    paymentOptionIdealLegacy: 'Betalen via iDEAL',
    paymentOptionCreditcard: 'Betalen met creditcard',
    paymentOptionIngenico: 'Betalen via iDEAL | Wero',
    paymentOptionIngenicoLegacy: 'Betalen via iDEAL',
  },
  en: {},
};
